// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_base_printable__aifiY","nonPrintable":"styles_base_nonPrintable__i_HRT","products":"styles_base_products__uD72b"};